import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-银行卡",
  "use": "icon-银行卡-usage",
  "viewBox": "0 0 1378 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1378 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-银行卡\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 882.688c0 78.048 63.104 141.312 140.896 141.312l1095.328 0c77.696 0 140.896-63.264 140.896-141.312l0-484.448-1377.088 0 0 484.448zM1236.224 0l-1095.328 0c-77.696 0-140.896 63.264-140.896 141.312l0 86.272 1377.088 0 0-86.272c0-78.048-63.104-141.312-140.896-141.312z\" p-id=\"3780\" fill=\"#3470e4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol